import IDimensions from "../model/IDimensions";
import { constants } from "../constants/constants";

const dealStorageService = {
  saveDeal(dimensions: IDimensions, dealData: string): void {
    const { brand, country, language } = dimensions;
    const dealPersistKey = `${ constants.DEAL }-${ brand }-${ country }-${ language }`;
    localStorage.setItem(dealPersistKey, dealData);
  },
  getDeal(dimensions: IDimensions) {
    const { brand, country, language } = dimensions;
    const dealPersistKey = `${ constants.DEAL }-${ brand }-${ country }-${ language }`;

    return JSON.parse(localStorage.getItem(dealPersistKey));
  },
  removeDeal(dimensions: IDimensions): void {
    const { brand, country, language } = dimensions;
    const dealPersistKey = `${ constants.DEAL }-${ brand }-${ country }-${ language }`;
    localStorage.removeItem(dealPersistKey);
  },
};

export default dealStorageService;
